import type {
  ProjectApi,
  ProjectsGetResultApi,
} from 'api-typings/projects/projects';
import type { AdminProject } from './admin-projects.model';
import { transformProjectAttachment } from '../project-view-projects/project-view-projects.transformers';
import { transformProject } from '../projects/projects.transformers';
import { transformSkill } from '../skills/skills.transformers';
import { transformLocation } from '../users/users-location.transformers';

export function transformAdminProject(
  project: ProjectApi,
  allSelectedBids: ProjectsGetResultApi['selected_bids'],
): AdminProject {
  return {
    ...transformProject(project, allSelectedBids),
    // Extra details for admin projects.
    description: project.description,
    skills: (project.jobs || []).map(transformSkill),
    location: project.location
      ? transformLocation(project.location)
      : undefined,
    attachments: (project.attachments || []).map(transformProjectAttachment),
    isBlasted: project.blasted ?? false,
  };
}
